module.exports = __webpack_public_path__ + "img/iphone.3f666f94.png";